import { GraphBuilder } from '../graph/builder';
import { ComponentDef } from './types';

export const lookaheadDecodingComponent: ComponentDef = {
  id: 'lookahead-decoding',
  name: 'Lookahead Decoding',
  description: 'Verify and accept n-gram draft tokens ahead of the current position to reduce decoding steps.',
  category: 'optimization',
  params: [
    { name: 'd_model', label: 'Model dimension', type: 'number', default: 512, min: 64, max: 4096, step: 64 },
    { name: 'seq_len', label: 'Sequence length', type: 'number', default: 128, min: 1, max: 8192, step: 1 },
    { name: 'window', label: 'Lookahead window', type: 'number', default: 5, min: 1, max: 32, step: 1 }
  ],
  buildGraph: (params) => {
    const d_model = Number(params.d_model);
    const seq_len = Number(params.seq_len);
    const window = Number(params.window);

    const g = new GraphBuilder();
    g.input('x', [seq_len, d_model]);
    g.linear('logits', 'x', [d_model, d_model]);
    g.cache('draft_cache', 'logits', [window, d_model]);
    g.linear('drafts', 'draft_cache', [d_model, window]);
    g.softmax('probs', 'drafts', 1);
    g.scale('verify', 'probs', 'Accept / Reject');
    g.output('out', 'verify');
    return g.build();
  }
};
